<template>
    <div class="diagnosis-section">
      <div class="diagnosis-content" style="margin-top: 200px;">
        <h1 class="title-about-our" style="padding: 0 100px;">“A veces, entender a tu hijo no requiere más fuerza... 
solo un nuevo lenguaje.”</h1>
        <a
            class="cta-button-big"
            href="https://api.whatsapp.com/send?phone=5215561461518&text=%C2%A1Quiero%20empezar%20mi%20diagn%C3%B3stico%20gratis!%F0%9F%98%80"
            target="_blank"
            rel="noopener"
        >
            INICIAR CONVERSACIÓN
        </a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PromSection'
  }
  </script>
  
  <style scoped>
  .diagnosis-section {
    width: 100%;
    height: 700px;
    background: url('../../assets/img/image-2.png') no-repeat center center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .diagnosis-content {
    display: flex;
    max-height: 1440px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    text-align: center;
  }
  .mistica-style-h3 {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 64px;
    align-items: center;
    color: #C58911;
    padding-bottom: 5%;
    padding: 50px 80px;
    transform: scaleY(1.2);
  }

  @media (max-width: 768px) {
  .diagnosis-section {
    height: auto;
    min-height: 140px;
    padding: 10px 0;
    background-size: cover;
  }
  .diagnosis-content {
    margin-top: 24px !important;
    gap: 12px;
    padding: 0 2vw;
    max-width: 100%;
  }
  .title-about-our {
    font-size: 16px;
    padding: 0 16px;
    line-height: 1.15;
    transform: scaleY(1.05);
    word-break: break-word;
  }
  .cta-button-big {
    font-size: 0.95rem;
    padding: 10px 24px;
    /* Sin width ni max-width, conserva el estilo original */
  }
}
  
  </style>
